var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIcTotalCentres = function SvgIcTotalCentres(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#F8F1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 22.75H24.75C25.0152 22.75 25.2696 22.8554 25.4571 23.0429C25.6446 23.2304 25.75 23.4848 25.75 23.75V36.25H15.25V23.75C15.25 23.4848 15.3554 23.2304 15.5429 23.0429C15.7304 22.8554 15.9848 22.75 16.25 22.75V22.75Z",
    stroke: "#DB147F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 36.25H34.75V15.25C34.75 14.8522 34.592 14.4706 34.3107 14.1893C34.0294 13.908 33.6478 13.75 33.25 13.75H24.25C23.8522 13.75 23.4706 13.908 23.1893 14.1893C22.908 14.4706 22.75 14.8522 22.75 15.25V19.75H24.25",
    stroke: "#DB147F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 36.25H13.75",
    stroke: "#DB147F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.75 36.25H36.25",
    stroke: "#DB147F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 16.75H27.25",
    stroke: "#DB147F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 25.75H17.5",
    stroke: "#DB147F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 36.25H18.25V33.25C18.25 32.8522 18.408 32.4706 18.6893 32.1893C18.9706 31.908 19.3522 31.75 19.75 31.75C20.1478 31.75 20.5294 31.908 20.8107 32.1893C21.092 32.4706 21.25 32.8522 21.25 33.25V36.25Z",
    stroke: "#DB147F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.75 36.25H28.75V31.75C28.75 31.3522 28.908 30.9706 29.1893 30.6893C29.4706 30.408 29.8522 30.25 30.25 30.25C30.6478 30.25 31.0294 30.408 31.3107 30.6893C31.592 30.9706 31.75 31.3522 31.75 31.75V36.25Z",
    stroke: "#DB147F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcTotalCentres, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-total-centres.fc9d01b9.svg";
export { ForwardRef as ReactComponent };